import { Checkbox } from "antd";
import { useAdvancedFormContext } from "../advanced-form";
import styled from "styled-components";

const StyledDisabledCheckbox = styled(Checkbox)`
  .ant-checkbox-inner {
    background: none;
  }
`

function FormItemCheckbox({ value, onChange, readOnly, disabled}: any) {
  const advancedFormContext = useAdvancedFormContext()
  const effectiveReadOnly = readOnly || advancedFormContext?.readOnly

  return <>
    { effectiveReadOnly && <StyledDisabledCheckbox disabled checked={value} /> }
    { !effectiveReadOnly && <Checkbox disabled={disabled} checked={value} onChange={evt => onChange(evt.target.checked)} /> }
    </>
}

export default FormItemCheckbox